import { createSlice } from "@reduxjs/toolkit";

export const locationSitesSlice = createSlice({
    name: "sitesSlice",
    initialState: {
        sites: [], // used in the siteContentModalComponent
        openLocationId: null
    },
    reducers: {
        setSites: (state, action) => {
            state.sites = [...action.payload];
        },
        setOpenLocationId: (state, action) => {
            state.openLocationId = action.payload;
        }
    }
});

export const { setSites, setOpenLocationId } = locationSitesSlice.actions;
export default locationSitesSlice.reducer;
